import { FinancialObligationParameter, AccountParameter , ParameterTypeEnum, PayrollParameters } from '@akiba/models_beta_temp';
import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-create-parameter-modal',
  templateUrl: './create-parameter-modal.component.html',
  styleUrls: ['./create-parameter-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateParameterModalComponent implements OnInit, OnChanges {

  parameter: AccountParameter | FinancialObligationParameter | undefined;
  @Input() parameterType: ParameterTypeEnum = ParameterTypeEnum.NotSet;
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['parameterType'] && changes['parameterType'].currentValue) {
      this.parameterType = changes['parameterType'].currentValue;
      this.procType();
    }
  }

  procType(): void {

    if (this.parameterType === ParameterTypeEnum.NotSet) {
      this.activeModal.dismiss(undefined);
    }

    const date = new Date();
    switch (this.parameterType) {
      case ParameterTypeEnum.Advance:
      case ParameterTypeEnum.Loan:
        this.parameter = new FinancialObligationParameter();
        this.parameter.id = date.getTime().toString();
        this.parameter.type = this.parameterType;
        break;

      case ParameterTypeEnum.LongAccount:
      case ParameterTypeEnum.ShortAccount:
      case ParameterTypeEnum.LongFund:
      case ParameterTypeEnum.ShortFund:
        this.parameter = new AccountParameter();
        this.parameter.id = date.getTime().toString();
        this.parameter.type = this.parameterType;
        break;
      default:
        break;

    }

  }

  createdParameter(): void {
    this.activeModal.close(this.parameter);
  }

}
